const STORAGE_KEY = "orders360.vista";

export interface ViewSettings {
  kpis: boolean;
  floatingFilters: boolean;
  filtersEnd: boolean;
}

export const DEFAULT_VIEW_SETTINGS: ViewSettings = { kpis: true, floatingFilters: false, filtersEnd: false };

export const isDefaultView = (settings: ViewSettings) =>
  settings.kpis === DEFAULT_VIEW_SETTINGS.kpis &&
  settings.floatingFilters === DEFAULT_VIEW_SETTINGS.floatingFilters &&
  settings.filtersEnd === DEFAULT_VIEW_SETTINGS.filtersEnd;

export const readViewSettings = (): ViewSettings => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}") || {};
    return {
      kpis: saved.kpis !== false,
      floatingFilters: saved.floatingFilters === true,
      filtersEnd: saved.filtersEnd === true,
    };
  } catch {
    return DEFAULT_VIEW_SETTINGS;
  }
};

export const saveViewSettings = (settings: ViewSettings) => {
  try {
    if (isDefaultView(settings)) localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, JSON.stringify(settings));
  } catch {
    return;
  }
};
